import HttpHelper from "./helper";

export const playerOfTheCompetitionGameEndpoints = {
  postAnswer: (inputData) =>
    HttpHelper.baseAxios
      .post(`/world-cup-player/submit`, inputData)
      .then((res) => res?.data)
      .catch((err) => err?.response?.data),
};
